import MockAdapter from 'axios-mock-adapter/types'

export function mockNotification(mocker: MockAdapter) {
  mocker.onGet('/message/account/page').reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          records: [
            {
              id: 1,
              title: 'test',
              userId: 2,
              content: 'contentcontentcontentcontentcontent',
              messageType: 2,
              link: '/1',
              isRead: false,
              createTime: 0,
            },
            {
              id: 2,
              title: 'test',
              userId: 2,
              content: 'contentcontentcontentcontentcontent',
              messageType: 2,
              link: '/1',
              isRead: false,
              createTime: 0,
            },
            {
              id: 11,
              title: 'test',
              userId: 2,
              content: 'contentcontentcontentcontentcontent',
              messageType: 2,
              link: '/1',
              isRead: false,
              createTime: 0,
            },
            {
              id: 21,
              title: 'test',
              userId: 2,
              content: 'contentcontentcontentcontentcontent',
              messageType: 2,
              link: '/1',
              isRead: false,
              createTime: 0,
            },
          ],
          total: 12, // record total number
          size: 10, // page limit
          current: 1,
        },
      },
    ]
  })
}
